import { createReducer, on } from '@ngrx/store';
import { ISessionItem } from './session.interface';
import { SessionActions } from './session.actions';
import { CurrentUserActions } from '../+current-user-store/current-user.actions';
import { IResponseError } from '../../service/interface';

export const sessionFeatureKey = 'session';

export interface IState {
	sessions: ISessionItem[];
	socketConnected: boolean;
	loading: boolean;
	error?: IResponseError;
}

export const initialState: IState = {
	sessions: [],
	socketConnected: false,
	loading: false,
};

export const reducer = createReducer(
	initialState,
	// ── API ──

	on(
		SessionActions.loadSessions,
		(state): IState => ({
			...state,
			loading: true,
			error: undefined,
		}),
	),
	on(
		SessionActions.loadSessionsSuccess,
		(state, action): IState => ({
			...state,
			sessions: action.sessions,
			loading: false,
			error: undefined,
		}),
	),
	on(
		SessionActions.loadSessionsError,
		(state, action): IState => ({
			...state,
			loading: false,
			error: action.error,
		}),
	),
	on(
		SessionActions.deleteSession,
		(state): IState => ({
			...state,
			loading: true,
			error: undefined,
		}),
	),
	on(
		SessionActions.deleteSessionSuccess,
		(state, action): IState => ({
			...state,
			sessions: state.sessions.filter(
				(session) => session.id !== action.sessionId,
			),
			loading: false,
			error: undefined,
		}),
	),
	on(
		SessionActions.deleteSessionError,
		(state, action): IState => ({
			...state,
			loading: false,
			error: action.error,
		}),
	),
	on(
		SessionActions.deleteAllOtherSessions,
		(state): IState => ({
			...state,
			loading: true,
			error: undefined,
		}),
	),
	on(
		SessionActions.deleteAllOtherSessionsSuccess,
		(state): IState => ({
			...state,
			sessions: state.sessions.filter((session) => session.isCurrent),
			loading: false,
			error: undefined,
		}),
	),
	on(
		SessionActions.deleteAllOtherSessionsError,
		(state, action): IState => ({
			...state,
			loading: false,
			error: action.error,
		}),
	),

	// ── UI ──

	on(
		SessionActions.clearSessionError,
		(state): IState => ({
			...state,
			error: undefined,
		}),
	),

	// ── Socket ──

	on(SessionActions.sessionCreatedViaSocket, (state, action): IState => {
		const [current, ...rest] = state.sessions;
		return {
			...state,
			sessions: [current, action.session, ...rest],
		};
	}),
	on(
		SessionActions.sessionDeletedViaSocket,
		(state, action): IState => ({
			...state,
			sessions: state.sessions.filter(
				(session) => session.id !== action.sessionId,
			),
		}),
	),
	on(
		CurrentUserActions.socketConnect,
		CurrentUserActions.socketReconnected,
		(state): IState => ({
			...state,
			socketConnected: true,
		}),
	),
	on(
		CurrentUserActions.socketDisconnected,
		CurrentUserActions.socketClose,
		(state): IState => ({
			...state,
			socketConnected: false,
		}),
	),
);
